module.exports = __webpack_public_path__ + "img/logo.91531e78.svg";